var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel-rows-wide',{style:(("margin-left: " + _vm.margin)),attrs:{"justify-end":"","categories":_vm.categories,"selectedPrinter":_vm.selectedPrinter},on:{"updateItem":_vm.updateTileData}})}
var staticRenderFns = []

export { render, staticRenderFns }